import { AddressEntity } from "./AddressEntity"
import { BaseModel } from "../Generics/BaseModel"
import { EGenderType } from "../../Enum/EGenderType"

export class PersonEntity extends BaseModel {
  id: number

  cpf: string

  rg: string

  name: string

  genderType: EGenderType

  phone: string

  email: string

  birthDate: string

  addresses: AddressEntity[]

  constructor(data: Partial<PersonEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.cpf = data.cpf ?? ""

    this.rg = data.rg ?? ""

    this.name = data.name ?? ""

    this.genderType = data.genderType ?? EGenderType.Man

    this.phone = data.phone ?? ""

    this.email = data.email ?? ""

    this.birthDate = data.birthDate ?? ""

    this.addresses = data.addresses?.map((e) => new AddressEntity(e)) ?? []
  }
}
